// extracted by mini-css-extract-plugin
export var splitLabel = "styles-module__splitLabel___xrTaf";
export var splitLabels = "styles-module__splitLabels___vblMY";
export var splits = "styles-module__splits___yOhDv";
export var splitsContainer = "styles-module__splitsContainer___p84xa";
export var title = "styles-module__title___UlsuA";